import SubNavMenuButton from '@/components/organisms/common/SubNavMenuButton';
import { useLocation } from 'react-router';

const CompanyUserNav = () => {
  const { pathname } = useLocation();
  return (
    <div className="flex items-baseline space-x-4">
      <SubNavMenuButton path={pathname} to="/company/user/list" label="회원 목록" />
      <SubNavMenuButton path={pathname} to="/company/user/register" label="회원 생성" />
    </div>
  );
};

export default CompanyUserNav;
